/**
 * Arduino Product Anchor Menu
 */

(() => {
    const anchorMenu = document.querySelector('.ino-anchor-menu');

    function onWindowScroll() {
        if(window.scrollY > 180) {
            anchorMenu.classList.add('is-active');
        } else {
            anchorMenu.classList.remove('is-active');
        }
    }

    function init() {
        if(!anchorMenu) {
            return;
        }

        scrollPosition = window.scrollY;

        window.addEventListener('scroll', onWindowScroll);
    }

    window.addEventListener('load', init);

})();